import * as React from 'react';
import { getAuthFromContext } from '@auth/business/auth.utils';
import { SignUpProLayout } from '@auth/components/SignUpProLayout/SignUpProLayout.component';
import { defaultNamespaces } from '@utils/strings';
import { castUrlParamToString, urlEnum } from '@utils/url';
import { PlcNextPage, PlcNextPageContext } from 'features/business/app.types';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

export type InscriptionProPageProps = { teamInviteToken?: string; inviteEmail?: string; redirectToMobileApp?: boolean };

const Inscription: PlcNextPage<Partial<InscriptionProPageProps>> = ({
  teamInviteToken,
  inviteEmail,
  redirectToMobileApp,
}) => {
  return (
    <SignUpProLayout
      inviteEmail={inviteEmail}
      redirectToMobileApp={redirectToMobileApp}
      teamInviteToken={teamInviteToken}
    />
  );
};

export async function getServerSideProps(ctx: PlcNextPageContext) {
  const { activationToken, email } = ctx.query;
  const teamInviteToken = castUrlParamToString(activationToken) ?? null;
  const inviteEmail = castUrlParamToString(email) ?? null;
  const redirectToMobileApp = ctx.query.redirectToMobileApp !== undefined;

  const { isAuthenticated } = await getAuthFromContext(ctx);
  if (isAuthenticated) {
    return {
      redirect: {
        destination: urlEnum.subscriptionPro,
        permanent: false,
      },
    };
  }

  return {
    props: {
      ...(await serverSideTranslations(ctx.locale || 'fr', defaultNamespaces)),
      inviteEmail,
      redirectToMobileApp,
      teamInviteToken,
    },
  };
}

export default Inscription;
